var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.pieID == 1 ? 'pieID' : _vm.pieID == 2 ? 'pieID2' : _vm.pieID == 3 ? 'pieID3' : 'pieID1',"option":_vm.option}})}
var staticRenderFns = []

export { render, staticRenderFns }